const Button = ({ children, link, variant, onclick }) => {
  return (
    <a href={link ?? '#'} onClick={onclick} className={'button ' + (variant ?? '')}>
    { children }
    </a>
  )
}

export default Button;